import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgFrameworkComponent } from 'ag-grid-angular';
import { ICellRenderer, ICellRendererParams } from 'ag-grid-community';

import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

export interface FormArrayTableToolsParams {
    existingRow: boolean;
    onAddRow: (data: any) => void;
    onRemoveRow: (data: any) => void;
    requiredProperties?: string[];
}

@Component({
    template: `
        @switch (params.node.isRowPinned()) {
            @case (true) {
                <button [disabled]="disableAddButton" mat-icon-button class="dense-compact" color="primary" (click)="add()">
                    <mat-icon>add_circle_outline</mat-icon>
                </button>
            }
            @case (false) {
                <button mat-icon-button class="dense-compact" color="error" (click)="remove()">
                    <mat-icon>remove_circle_outline</mat-icon>
                </button>
            }
        }
    `,
    styles: [``],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconButton, MatIcon]
})
export class FormArrayTableToolsCellRendererComponent implements ICellRenderer, AgFrameworkComponent<FormArrayTableToolsParams> {
    public params!: ICellRendererParams & FormArrayTableToolsParams;

    agInit(params: ICellRendererParams & FormArrayTableToolsParams) {
        this.params = params;
    }

    refresh(params: ICellRendererParams & FormArrayTableToolsParams): boolean {
        return false;
    }

    add() {
        const { tools, ...data } = this.params.data;
        this.params.onAddRow(data);
    }
    remove() {
        this.params.onRemoveRow(this.params.data);
    }

    public get disableAddButton(): boolean {
        const { tools, ...data } = this.params.data;
        const required = this.params.requiredProperties || [];
        for (const col of required) {
            if (!Object.prototype.hasOwnProperty.call(data, col) || data[col] === undefined || data[col] === null || data[col] === '') {
                return true;
            }
        }
        return false;
    }
}
